import React, {useState} from "react";
import { Hero } from "./hero/Hero";
import { Posts } from "./posts/Posts";
import { Products } from "./products/Products";
import {Spinner} from "./../../spinner/Spinner";
import { Seo } from "../../seo/Seo";

export const Home = ({posts, products, isLoading, setIsLoading}) => {

  const [showMore, setShowMore] = useState(false);
  
  return (
    <>
      <Seo 
        title={`Adviso`}
        description={`Prodotti consigliati da acquistare su Amazon in questo momento`}
        imageUrl={`${require('./../../../assets/logo-small.png')}`}
      />
      <div className="home">
        <Spinner isLoading={isLoading} setIsLoading={setIsLoading} />
        <Hero />
        <Posts posts={posts} setIsLoading={setIsLoading} />
        <div className="container">
          <div className="info-affiliazione">
            <div className="icona">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none"><path fill="#000" d="M8.492 6.9101A.5002.5002 0 0 0 7.5002 7v4.5021l.008.0899a.5.5 0 0 0 .992-.0899V7l-.008-.0899ZM8.7989 4.75a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0ZM16 8c0-4.4183-3.5817-8-8-8S0 3.5817 0 8s3.5817 8 8 8 8-3.5817 8-8ZM1 8c0-3.866 3.134-7 7-7s7 3.134 7 7-3.134 7-7 7-7-3.134-7-7Z" /></svg>
            </div>
            <div className="testo">
              <span>
                Questo sito partecipa al Programma di Affiliazione Amazon, 
                un'iniziativa che consente ai siti di guadagnare commissioni pubblicitarie 
                attraverso la promozione di link e prodotti di Amazon. Se decidi di acquistare 
                un prodotto tramite uno dei link presenti su questo sito 
                potremmo ricevere una commissione, senza alcun costo aggiuntivo per te. 
              </span>
              {showMore && (
                <>
                  <br />
                  <span>
                    Le opinioni espresse su questo sito sono personali e indipendenti 
                    e i link affiliazione vengono selezionati in base alla rilevanza 
                    e qualità dei prodotti, non per motivi commerciali. 
                    Amazon e il logo Amazon sono marchi registrati di Amazon.com, Inc. 
                    o delle sue consociate.
                  </span>
                </>
              )}
              <a 
                href="javascript:void(0)" 
                onClick={() => {
                  setShowMore(!showMore);
                }}
              >
                {showMore ? `Leggi di meno` : `Leggi di più`}
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};